import { Edit, ExitToAppSharp, Delete, AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

import { TableActions } from "../../components/v3";

/**
 * Route paths for the tools module.
 * Single source of truth — reuse these instead of hard-coding `/tools...` strings.
 */
export const TOOLS_ROUTES = {
  root: "/tools",
  details: "/tools/:id",
} as const;

export const getToolTableColumns = (handleActions, hasEditTool, hasDeleteTool) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.5, sortable: false },
    { field: "name", headerName: "Name", flex: 1, sortable: true },
    { field: "description", headerName: "Description", flex: 1.5 },
    { field: "code", headerName: "Code", flex: 1 },
    { field: "totalQuantity", headerName: "Quantity", flex: 1 },
  ];

  if (hasEditTool || hasDeleteTool) {
    headers.push({
      field: "actions",
      headerName: "Action",
      sortable: false,
      flex: 0.5,
      renderCell: (params) => {
        const actions = [];

        if (hasEditTool) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }

        if (hasDeleteTool) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }
  return headers;
};

export const getAssignedToolsTableColumns = (handleActions, hasMoveTool, hasUpdateStock) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.4, sortable: false },
    { field: "storeName", headerName: "project / WareHouse", flex: 1.5, sortable: false },
    { field: "count", headerName: "count", flex: 0.5, sortable: false },
  ];

  if (hasMoveTool || hasUpdateStock) {
    headers.push({
      field: "actions",
      headerName: "Action",
      sortable: false,
      flex: 0.9,
      renderCell: (params) => {
        const { count } = params.row;
        const actions = [];

        if (hasUpdateStock) {
          actions.push(
            {
              icon: AddCircleOutline,
              type: "increment",
              label: "Add stock",
              onClick: handleActions,
            },
            {
              icon: RemoveCircleOutline,
              type: "decrement",
              label: "Remove stock",
              onClick: handleActions,
              disabled: count === 0,
            },
          );
        }

        if (hasMoveTool) {
          actions.push({
            icon: ExitToAppSharp,
            type: "move",
            label: "Move Tool",
            onClick: handleActions,
            disabled: count === 0,
          });
        }

        return <TableActions item={params} actions={actions} />;
      },
    });
  }

  return headers;
};
